// See documentation at ontech.state.readme.md

window.ontech = window.ontech || {};
window.ontech.state = window.ontech.state || {};
window.ontech.actions = window.ontech.actions || {};

let actions = {};


actions.onCartModified = function (value) {
    ontech.state.set(State.Cart.IS_MODIFIED, value);
}

actions.onCartUpsellsChanged = function (upsellData) {
    ontech.state.set(State.Cart.UPSELL_DATA, JSON.stringify(upsellData));
}

actions.onAgentChanged = function (agentId) {
    ontech.state.set(State.AGENT_ID, agentId);
}

actions.onCheckoutShippingMethodChanged = function (value) {
    ontech.state.set(State.CHECKOUT_SHIPPING_METHOD, value);
}

actions.onCheckoutStateChanged = function (value) {
    ontech.state.set(State.CHECKOUT_STATE, value);
}

actions.onGeneralActionChanged = function (action) {
    ontech.state.set(State.ACTION, action);
}

actions.onCustomerChanged = function (customerInfo) {
    ontech.state.set(State.Customer.EMAIL_ADDRESS, customerInfo.emailAddress);
}

actions.clearOntechStorage = function (clearParams) {
    try {
        // *** "nuclear" reset ***
        if (clearParams.mode === UserMode.ALL) {
            ontech.removeCookiesByPrefix('ontech_', ['ontech_session_idCreated', CookiesConstants.THEME_ID]);
            ontech.removeLocalStorageByPrefix('ontech_');
            
            // Initialize to default state
            ontech.state.resetState();
            UpdateCartMembershipBenefits();
            return;
        }

        // *** Global clear ***
        ontech.state.clear(State.Partner.ENABLED_PDP_AVAILABILITY_CHECK); // enable availability on PDP (partner config)

        ontech.state.set(State.Customer.EMAIL_ADDRESS, { 'emailAddress': null });  // used for logging only TODO: STATE: ROUND #2

        ontech.removeCookie(CookiesConstants.Oss.PARENT_ORDER_NUMBER); // in current prod - clearing parent globally, is this necessary?
        ontech.state.clear(State.ParentOrder.NUMBER);
        ontech.state.clear(State.ParentOrder.WORK_ORDER);

        ontech.removeCookie(CookiesConstants.Oss.TECH_DELIVERED);  // in current prod - clearing parent globally, is this necessary?
        ontech.state.clear(State.Oss.TECH_DELIVERED);
      
        ontech.state.clear(State.ACTION);
        
        ontech.removeCookie(CookiesConstants.Oss.CUSTOMER_NAME); // sha, probably not necessary
        ontech.state.clear(State.Oss.CUSTOMER_NAME);
        
        ontech.removeCookie(CookiesConstants.Oss.CUSTOMER_EMAIL); // sha, probably not necessary
        ontech.state.clear(State.Oss.CUSTOMER_EMAIL);
        
        ontech.removeCookie(CookiesConstants.Oss.VALID_GWPS); // oss, probably not necessary
        ontech.state.clear(State.Partner.ENABLED_PDP_AVAILABILITY_CHECK);
        
        ontech.removeCookie(CookiesConstants.Oss.PARENT_ORDER_MEMBER); // oss, probably not necessary
        ontech.state.clear(State.ParentOrder.IS_MEMBER);

        ontech.state.clear(State.VENDOR_DEALS.SLIDE_CART_DISABLED); // VendorDeals, After this flow we need to enable slide-cart in normal flow
        ontech.state.clear(State.VENDOR_DEALS.REFERRER);
        ontech.state.clear(State.VENDOR_DEALS.CONTACT_INFO_PAGE_LOAD);
        /*
        --- Checkout ---
        - ontech_checkout_shipping_method
        - ontech_checkout_state
        */
        ontech.removeCookiesByPrefix(CookiesConstants.CHECKOUT_PREFIX);  // Used in workaround for writing Tech Delivered flag in checkout
        //ontech.state.clear('checkout'); // TODO: DO WE HAVE CHECKOUT KEYS YET? NEEDED?
        
        /*
        --- Partner ---
        - ontech_partner_hideEmptySlideCartContents        
        - ontech_partner_id
        - ontech_partner_showCartItemsRemovedMessage        
        - ontech_partner_showExclusiveCartClearedMessage
        - ontech_partner_skipCart
        - ontech_partner_slideCartDisabled
        - ontech_partner_url
        */
        ontech.removeCookiesByPrefix(CookiesConstants.Partners.PREFIX);
        ontech.state.clear(State.Partner.PARTNER);
        
        // *** Homepage Only ***
        if (clearParams.mode === UserMode.HOMEPAGE) {
            ontech.state.clear(State.CLIENT_NAME);
            ontech.removeCookie(CookiesConstants.CUSTOMER_ID); // Used by SHA for customer refund, don't clear for OSS/Agent
            ontech.removeCookie(CookiesConstants.Oss.ORIGINAL_URL);
            ontech.state.clear(State.Oss.CUSTOMER_ID);
        }

        // *** Agent Only ***
        // Don't clear on OSS flow
        if (clearParams.mode === UserMode.AGENT) {
            ontech.state.clear(State.AGENT_ID); // Don't clear on homepage or will lose agent id during ATT flow
        }

        // *** OSS + Agent Only ***
        /*
        The OSS + Agent flow is fully resetting the session. Therefore the reset is more thorough than the homepage reset.
        */
        if (clearParams.mode === UserMode.OSS || clearParams.mode === UserMode.AGENT) {
            // PHASE 2
            ontech.removeCookie(CookiesConstants.INDIRECT_PARTNER_CODE); // note: clearing this for ontech would break indirect partner flow
            ontech.state.clear(State.Partner.INDIRECT_PARTNER_CODE); // TODO: GROUP #2
            /*
            --- Caching ---
            - ontech_cache_cart
            - ontech_cache_isCartModified
            */
            // NOTE: On current prod, not clearing any of these on homepage
            ontech.removeLocalStorageByPrefix(StorageConstants.Cache.PREFIX);

            /*
            --- Order Edit ---
            - ontech_orderedit_orderNumber
            - ontech_orderedit_original (price)
            - ontech_orderedit_subtotalPrice
            - ontech_orderedit_totalPrice
            */
            ontech.removeCookiesByPrefix(CookiesConstants.OrderEdit.PREFIX);
            ontech.state.clear(State.OrderEdit.ORDER_EDIT);

            /*
            --- Logging ---
            */
            ontech.removeCookiesByPrefix(CookiesConstants.LOG_PREFIX);

            /*
            --- OSS ---
            */
            ontech.removeCookiesByPrefix(CookiesConstants.Oss.PREFIX);
            ontech.state.clear(State.Oss.CUSTOMER_ID);
            ontech.state.clear(State.Oss.CUSTOMER_EMAIL);
            ontech.state.clear(State.Oss.CUSTOMER_NAME);
            ontech.state.clear(State.Oss.DYNAMIC_PRICING_REQUIRE_FULL_PRICE_INSTALL);
            ontech.state.clear(State.Oss.IS_TROUBLE_CALL);
            ontech.state.clear(State.Oss.PARENT_ORDER_MEMBER_EMAIL);
            ontech.state.clear(State.ParentOrder.IS_MEMBER);
            ontech.state.clear(State.ParentOrder.MEMBERSHIP_INFO);
            ontech.state.clear(State.Oss.PARENT_ORDER_MEMBERSHIP_SKU);
            ontech.state.clear(State.ParentOrder.NUMBER);
            ontech.state.clear(State.ParentOrder.WORK_ORDER);
            ontech.state.clear(State.Oss.PARENT_PARTNER_ID);
            ontech.state.clear(State.Oss.TECH_DELIVERED);
            ontech.state.clear(State.Oss.VALID_GWPS);

            /*
            --- Scheduler ---
            */
            ontech.removeCookiesByPrefix(CookiesConstants.SCHEDULER_PREFIX);
            ontech.state.clear(State.Scheduler.SCHEDULER);

            /*
            --- SHA ---
            - ontech_sha_active
            - ontech_sha_customerDiscount
            */
            ontech.removeCookiesByPrefix(CookiesConstants.SHA);
            ontech.state.clear(State.SHA);
        }


        // *** Membership ***
        /*
        Cookies:
        // - ontech_membership_active - Flag indicating membership either in cart or member logged in
        - ontech_membership_disabled - Partner config setting
        - ontech_membership_showPricingUpdatedMessage
        - ontech_membership_showRemovedMessage
        */
        if (clearParams.mode === UserMode.HOMEPAGE) {
            // *** Do not clear ontech_membership_inCart or will lose membership benefits on active cart ***
            // *** Do not clear ontech_membership_totalBenefitValue, needed for cart ***
            ontech.removeCookie(CookiesConstants.Membership.DISABLED);  // partner switch, yes clear
            ontech.state.clear(State.Testing.DISABLE_MEMBERSHIP_CART_UPDATE); // TEST ONLY FLAG
            ontech.state.clear(State.Membership.IS_ENABLED);

            ontech.state.clear(State.Membership.FREE_INSTALL_OVERRIDE);
            ontech.state.clear(State.Membership.FREE_INSTALLS_REMAINING);
            ontech.removeCookie(CookiesConstants.Membership.SHOW_PRICING_UPDATE_MESSAGE); // Flag to display "We've updated your cart" message NO NEED TO CLEAR ON HOME
            ontech.removeCookie(CookiesConstants.Membership.SHOW_REMOVED_MESSAGE);  // flag to display we removed membership because you're already a member message NO NEED TO CLEAR ON HOME
            ontech.removeCookie(CookiesConstants.Membership.MONTHLY_SHW_REMOVED_MESSAGE);  // flag to display we removed membership because you're already a member message NO NEED TO CLEAR ON HOME
        } else {
            // oss | agent | all
            // Bulk clear all membership storage in OSS / Agent
            ontech.state.clear(State.Membership.MEMBERSHIP);
            ontech.removeCookiesByPrefix(CookiesConstants.Membership.PREFIX);
            ontech.removeLocalStorageByPrefix(StorageConstants.MEMBERSHIP_PREFIX);

        }
            
        // *** Final Steps ***
        if (clearParams.mode === UserMode.AGENT) {
            ontech.state.set(State.CLIENT_NAME, ClientNames.D2C_ONTECH);
        }
    } catch (err) {
        ontech.log.error(`Error clearing ontech storage ${clearParams.mode}, ${clearParams.source}: "${err}"`, err);
    }
}

actions.onGeneralOrderEditClientNameChanged = function (value) {
    ontech.state.set(State.OrderEdit.CLIENT_NAME, value);
}

actions.onGeneralClientNameChanged = function (value) {
    ontech.state.set(State.CLIENT_NAME, value);
}

actions.onGeneralSessionChanged = function (sessionInfo) {
    ontech.state.set(State.SESSION_ID, sessionInfo.sessionId);
    ontech.state.set('general.sessionCreatedDate', sessionInfo.sessionCreatedDate); 
}

actions.onCartItemAdded = function (source) {
    ontech.log.debug(`$$$ action: onCartItemAdded(${source}) $$$`);
}

actions.onCartItemRemoved = function (source) {
    ontech.log.debug(`$$$ action: onCartItemRemoved(${source}) $$$`);
}

actions.onAgentLoad = function (source) {
    ontech.log.debug(`$$$ action: onLogin(${source}) $$$`);
}

actions.onOssLoad = function (source) {
    ontech.log.debug(`$$$ action: onLogin(${source}) $$$`);
}

actions.onLogOrderAttributeStepsChanged = function (step) {
    ontech.state.set(State.LOG_ORDER_ATTRIBUTE_UPDATE_STEPS, step);
}

actions.onLogin = function (source) {
    ontech.log.debug(`$$$ action: onLogin(${source}) $$$`);
}

actions.onMember = function (source) {
    ontech.state.set(State.Membership.ACTIVE, true);
    ontech.state.set(State.Membership.IS_MEMBER, true);
    ontech.log.debug(`$$$ action: onMember(${source}) $$$`);
}

actions.onRegister = function (source) {    
    ontech.log.debug(`$$$ event: onLogin (${source})$$$`);
}

actions.onMembershipAdded = function () {
    ontech.state.set(State.Membership.IN_CART, true);
    ontech.state.set(State.Membership.ACTIVE, true);
}

actions.onMonthlyMembershipAdded = function () {
    ontech.state.set(State.Membership.MONTHLY_MEMBERSHIP_IN_CART, true);
}

actions.onMonthlyMembershipRemoved = function () {
    ontech.state.set(State.Membership.MONTHLY_MEMBERSHIP_IN_CART, false);
}

actions.onMembershipTotalBenefitValueChanged = function (value) {
    ontech.state.set(State.Membership.TOTAL_BENEFIT_VALUE, value);
}

actions.onMembershipNumFreeInstallsOverrideChanged = function (value) {
    ontech.state.set(State.Membership.FREE_INSTALL_OVERRIDE, value);
}

actions.onMembershipRemoved = function () {
    ontech.state.set(State.Membership.IN_CART, false);
    ontech.state.set(State.Membership.ACTIVE, false);
}

actions.onMembershipSetFreeInstallsRemaining = function (value) {
    ontech.state.set(State.Membership.FREE_INSTALLS_REMAINING, value);
}

actions.onOrderEdit = function (orderEditInfo) {
    ontech.state.set(State.OrderEdit.ORDER_NUMBER, orderEditInfo.orderNumber);
    ontech.state.set(State.OrderEdit.SUB_TOTAL_PRICE, orderEditInfo.subtotalPrice);
    ontech.state.set(State.IS_DROP_SHIP_ORDER, orderEditInfo.isDropShipOrder);
    ontech.state.set(State.OrderEdit.INSTALLATION_DATE, orderEditInfo.installationDate);
}

actions.onOrderEditOriginalPrice = function (value) {
    ontech.state.set(State.OrderEdit.ORIGINAL_PRICE, value);
}

actions.onOssParentOrderNumberChanged = function (value) {
    ontech.state.set(State.ParentOrder.NUMBER, value);
}

actions.onAdtCsSet = function (value) {
    ontech.state.set(State.Adt.CS_NUMBER, value);
}

actions.onAdtSiteSet = function (value) {
    ontech.state.set(State.Adt.SITE_NUMBER, value);
}
actions.onOssTechIdChanged = function (value) {
    ontech.state.set(State.TECH_ID, value);
}

actions.onOssTechDeliveredChanged = function (value) {
    ontech.state.set(State.Oss.TECH_DELIVERED, value);
}

actions.onUpdateTimer = function (value) {
    let newTime = value.toString();
    ontech.state.set(State.Oss.SESSION_TIMEOUT_DATE, newTime);
    ontech.log.debug(`$$$ oss.timeLastUpdated = ${newTime}`);
}

actions.onPartnerChanged = function (params) {
    if (!ontech.state.get(State.Partner.LOCK_CLIENT_NAME)) {
        ontech.state.set(State.CLIENT_NAME, params.clientName);
    }
    ontech.state.set(State.HIDE_EMPTY_SLIDE_CART, params.hideEmptySlideCartContents);
    ontech.state.set(State.Membership.IS_ENABLED, params.membershipEnabled);
    ontech.state.set(State.Partner.ID, params.partnerId);
    ontech.state.set(State.Partner.URL, params.partnerUrl);
    ontech.state.set(State.Partner.ENABLED_PDP_AVAILABILITY_CHECK, params.pdpAvailabilityCheckEnabled);
    ontech.state.set(State.Partner.SKIP_CART, params.skipCart);
    ontech.state.set(State.Partner.ENABLED_SLIDE_CART, params.slideCartEnabled);

    // the partnerId still needs to be in cookies for the header/footers to work
    ontech.state.set(State.Partner.ID, params.partnerId);
}

actions.onPartnerIdChanged = function (partnerId) {
    ontech.state.set(State.Partner.ID, partnerId);
}

actions.onClearHomepage = function () {
    ontech.state.clear(State.Membership.FREE_INSTALL_OVERRIDE);
    ontech.state.clear(State.Membership.FREE_INSTALLS_REMAINING);
}

actions.onClearFreeInstallsRemaining = function () {
    ontech.state.clear(State.Membership.FREE_INSTALLS_REMAINING);
}

actions.onCheckMembershipOption = function () {
    ontech.state.set(State.Membership.OPTION_CHECKED, true);
}

actions.onOrderEditProcessing = function (orderEditData) {
    ontech.state.set(State.OrderEdit.ORDER_NUMBER, orderEditData.orderNumber);
    ontech.state.set(State.OrderEdit.SUB_TOTAL_PRICE, orderEditData.subtotalPrice);
}

actions.onRouterEnter = function (routerData) {
    ontech.state.set(State.Oss.CUSTOMER_ID, routerData.customerId);
    ontech.state.set(State.Oss.CUSTOMER_EMAIL, routerData.customerEmailAddress);
    ontech.state.set(State.Oss.CUSTOMER_NAME, routerData.customerName);
    ontech.state.set(State.Oss.DEFAULT_ADDRESS, routerData.defaultAddress);
    ontech.state.set(State.Oss.DYNAMIC_PRICING_REQUIRE_FULL_PRICE_INSTALL, routerData.dynamicPricingRequireFullPriceInstall);
    ontech.state.set(State.ParentOrder.NUMBER, routerData.parentOrderNumber);
    ontech.state.set(State.ParentOrder.IS_MEMBER, routerData.parentOrderIsMember);
    ontech.state.set(State.ParentOrder.MEMBERSHIP_INFO, JSON.stringify(routerData.parentOrderMembershipInfo));
    ontech.state.set(State.Oss.PARENT_ORDER_MEMBERSHIP_SKU, routerData.parentOrderMembershipSku);
    ontech.state.set(State.Oss.VALID_GWPS, routerData.validGwps);
    ontech.state.set(State.Customer.SHA_REFUND, routerData.customerShaRefunded);
}

actions.onUncheckMembershipOption = function () {
    ontech.state.set(State.Membership.OPTION_CHECKED, false);
}

actions.dspTestAction = function () {
    ontech.state.set(State.CLIENT_NAME, 'changed!');
}

actions.onClearCart = function () {
    ontech.state.set(State.Membership.IN_CART, false);
}

actions.onSchedulerItemsNotAvailableMessageChanged = function (value) {
    ontech.state.set(State.Scheduler.ITEMS_NOT_AVAILABLE_MESSAGE, value);
}

actions.onSchedulerSubmitted = function (value) {
    ontech.state.set(State.Scheduler.SUBMITTED, value);
}

actions.onShaHaveQuote = function (value) {
    ontech.state.set(State.HAVE_QUOTE, value);
}

actions.onShaCustomerDiscountChanged = function (value) {
    ontech.state.set(State.Customer.DISCOUNT, value);
}

//Gift code for OG
// actions.onOGCustomerDiscountChanged = function (value) {
//     ontech.state.set(State.Membership.OG_DISCOUNT, value);
// }

/*** Testing ***/
actions.onDisableMembershipCartUpdateChanged = function (value) {
    ontech.state.set(State.Testing.DISABLE_MEMBERSHIP_CART_UPDATE, value);
}

actions.onZipCodeChanged = function (zipCode) {
    ontech.state.set(State.ZIP_CODE, zipCode);
}

actions.onUpsellChanged = function (uptracker) {
    ontech.state.set(State.UP_TRACKER, uptracker);
}

actions.onSpecialChanged = function (spTracker) {
    ontech.state.set(State.SP_TRACKER, spTracker);
}

actions.setMembershipAttribute = function (source) {
    let value = null;
    const isMembershipLinePresentInCart = ontech.state.get(State.Membership.IN_CART);
    const membershipStartDate = ontech.state.get(State.Membership.START_DATE);
    const memberShipExpirationDate = ontech.state.get(State.Membership.EXPIRATION_DATE);

    if (source !== "resetMembershipAttribute") {
        if (ontech.state.get(State.Membership.IS_MEMBER)) {
            //if customer is member and he is renewing his membership
            if (isMembershipLinePresentInCart) {
                value = Membership.Status.RENEWED
            } else {
                value = Membership.Status.EXISTING
            }
        } else {
            //if ex-customer is buying membership, set attribute to Membership.Status.RENEWED
            if (membershipStartDate && memberShipExpirationDate && isMembershipLinePresentInCart) {
                value = Membership.Status.RENEWED
            } else if (isMembershipLinePresentInCart) {
                value = Membership.Status.NEW
            }
        }
    }
    ontech.state.set(State.Membership.STATUS, value);
}

actions.onLogout = function () {
    ontech.state.clear(State.Customer.CUSTOMER);
    ontech.state.clear(State.Membership.IS_MEMBER);
    ontech.state.do(State.Actions.SET_MEMBERSHIP_ATTRIBUTE, 'actions.onLogout');
}

actions.onForcedLogin = function () {
    ontech.state.set(State.FORCED_LOGIN, true);
}

actions.onAfterForcedLogin = function () {
    ontech.state.clear(State.FORCED_LOGIN);
}

actions.onCheckoutSendStateLog = function () {
    try {
        if (ontech.state.get(State.Settings.ENABLE_LOG_STATE)) {
            let currentState = ontech.state.get();
            _makePostCall(
                `${getShopifyUrl()}/logState`,
                JSON.stringify(currentState)
            ).catch(err => {
                let errMsg = 'Error sending state log on checkout';
                window.ontech.log.error(errMsg, err);
            });
        }
    } catch (err) {
        let errMsg = 'Error sending state log on checkout';
        window.ontech.log.error(errMsg, err);
    }
}

actions.onNewTab = function () {
    ontech.state.set(State.NEW_TAB, true);
}

actions.onBundleAvailabilityCheck  = function (bundleData) {
    ontech.state.set(bundleData.bundle, bundleData.qty)
}

actions.onProductAvailabilityCheck = function (productData) {
    let productAvailabilityObject = ontech.state.get(State.PRODUCT_AVAILABILITY)
    if (JSON.stringify(productAvailabilityObject) === '{}') {
     productAvailabilityObject = {}
    }
    let newObj = {};
    newObj[productData.prodSku] = productData.qty;
    productAvailabilityObject = Object.assign(productAvailabilityObject, newObj)
    ontech.state.set(State.PRODUCT_AVAILABILITY, productAvailabilityObject )
}

actions.getMemberLevel = async function () {
    let membershipLevel;
    const variantId = ontech.state.get(State.Membership.PLAN_VARIANT);

    // ontech.log.debug('check variant id', variantId)
    membershipLevel = ''
    if (!isEmpty(variantId)) {
        let variant;
        variant = await getVariantInfo(variantId);
        membershipLevel = await getMetafieldByKey(variant.product_id, 'membership_level');
    }
    // ontech.log.debug('member level', membershipLevel);
    ontech.state.set(State.Membership.LEVEL, membershipLevel);
}

actions.updateState = function (keyValue){
    if(isEmpty(keyValue)){
        throw Error('An object with state key and value is needed')
    }

    if(isEmpty(keyValue.key)){
        throw Error('Key is needed to update state')
    }

    return ontech.state.set(keyValue.key, keyValue.value);
}

actions.vendorslideCartDisabled = function (slideCart){
    ontech.state.set(State.VENDOR_DEALS.SLIDE_CART_DISABLED, slideCart);
}

actions.vendorReferrer = function (referrer){
    ontech.state.set(State.VENDOR_DEALS.REFERRER, referrer);
}
actions.vendorEditZipCode = function (showEditZipCode){
    ontech.state.set(State.VENDOR_DEALS.SHOW_EDIT_ZIP_CODE, showEditZipCode);
}
actions.vendorCustomerEmail = function (customerEmail){
    ontech.state.set(State.VENDOR_DEALS.CUSTOMER_EMAIL, customerEmail);
}

actions.vendorContactInfoPageLoad = function (contactInfo){
    ontech.state.set(State.VENDOR_DEALS.CONTACT_INFO_PAGE_LOAD, contactInfo);
}

window.ontech.actions = actions;